import React, { createContext } from 'react';

/**
 * @type {React.Context<{
 *  isOpen: boolean,
 *  onToggle: () => void
 * }>}
 */
const CollapseContext = createContext();

export const CollapseProvider = CollapseContext.Provider;

export const useCollapse = () => {
  const context = React.useContext(CollapseContext);
  if (!context) {
    throw new Error('useCollapse must be used within a CollapseProvider');
  }
  return context;
};
